/**
 * Logger condicional que solo activa logs en desarrollo
 * En producción solo se muestran errores críticos
 */

const isDevelopment = 
  import.meta.env.DEV || 
  (typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname.includes('lovable.app')
  ));

const logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDevelopment) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Errores siempre se loggean
    console.error(...args);
  },
  debug: (...args: unknown[]) => {
    if (isDevelopment) console.debug(...args);
  },
  // Para logs de API (nunca en producción por seguridad)
  api: (...args: unknown[]) => {
    if (isDevelopment) console.log('[API]', ...args);
  }
};

export default logger;
